<tgrid-restoration-metric-map-widget
  title="Recovery Duration"
  metric="recovery_duration"
  mapId="restoration-metric-recovery-duration-widget"
  countyLabelPrefix="Counties with longest recovery duration:"
  subtitle="Recovery Duration measures the time between the maximum number of customers are impacted (Impact Level) and the end of the outage event."
  exportFileName="restoration_metric_recovery_duration">
</tgrid-restoration-metric-map-widget>
